/**
 * フォームの情報
 */
const headTitleList: any[] = [
  {
    headTitle: "申請ID",
  },
  {
    headTitle: "申請・届出（手続き）",
  },
  {
    headTitle: "都道府県",
  },
  {
    headTitle: "共済契約者",
  },
  {
    headTitle: "申請日時",
  },
  {
    headTitle: "状況",
  },
  {
    headTitle: "担当者",
  },
  {
    headTitle: "新担当者",
  },
];

export { headTitleList };
